import { FastField, Formik } from 'formik';
import { motion } from 'framer-motion';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

SignInForm.propTypes = {
  onSignIn: PropTypes.func,
};

SignInForm.defaultProps = {};

function SignInForm(props) {
  // MARK: --- Params ---
  const { t } = useTranslation();
  const { onSignIn } = props;
  const router = useRouter();

  const savedLoginEmail = localStorage.getItem(PreferenceKeys.savedLoginEmail);

  // MARK: --- Functions ---
  function handleSubmit(values) {
    onSignIn(values);
  }

  const handlePreventSignupSaleDialog = () => {
    AppDialogHelper.show(
      'Đăng ký đại lý',
      t(
        'Chức năng này hiện tại không khả dụng, vui lòng thử lại sau hoặc liên hệ với nhà điều hành EVG'
      ),
      [
        {
          title: t('Đóng'),
          type: 'neutral',
          onClick: () => {
            AppDialogHelper.hide();
          },
        },
      ],
      false,
      AppResource.images.dialogIcons.dialogError
    );
  };

  return (
    <motion.div
      className="login-form"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      {/* form */}
      <Formik
        initialValues={{
          email: savedLoginEmail ?? '',
          password: '',
        }}
        validationSchema={Yup.object({
          email: Yup.string().required(t('emailRequired'))
            .test('len', t('Email không hợp lệ', { field: 'email' }), (val) => {
              if (val) {
                return (
                  !val.toString().includes(' ') &&
                  val.toString().match(AppConfigs.regex.email)
                )
              }
              return false;
            }),
          password: Yup.string().required(t('passwordRequired')),
        })}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {(formikProps) => (
          <form
            className="form fv-plugins-bootstrap fv-plugins-framework"
            onSubmit={formikProps.handleSubmit}
            noValidate
          >
            {/* title */}
            <div className="pb-8 pt-lg-0 pt-5 text-center">
              <h3
                className="font-weight-boldest text-dark"
                style={{
                  fontSize: Utils.returnFontSize(30),
                  color: '#181C32',
                }}
              >
                Đăng nhập
              </h3>
              <p
                className="font-weight-bolder"
                style={{
                  fontSize: Utils.returnFontSize(16),
                  color: '#A1A5B7',
                }}
              >
                Hệ thống quản lý trạm sạc xe điện
              </p>
            </div>

            {/* form group */}
            <KTFormGroup
              label="Email"
              inputName="email"
              additionalClassName="fv-plugins-icon-container"
              additionalLabelClassName="font-size-h6 font-weight-bolder text-gray-700"
              inputElement={
                <FastField name="email">
                  {({ field, form, meta }) => (
                    <KTFormInput
                      name={field.name}
                      value={field.value}
                      onChange={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                      onBlur={() => {
                        form.setFieldTouched(field.name, true);
                      }}
                      enableCheckValid
                      isValid={_.isEmpty(meta.error)}
                      isTouched={meta.touched}
                      feedbackText={meta.error}
                      type={KTFormInputType.email}
                      solidBackground
                      additionalInputClassName="h-auto p-6 rounded-lg"
                      placeholder={t('enterEmail')}
                    />
                  )}
                </FastField>
              }
            />

            <KTFormGroup
              label={t('password')}
              inputName="password"
              additionalClassName="fv-plugins-icon-container"
              additionalLabelClassName="font-size-h6 font-weight-bolder text-gray-700"
              labelAdditionalComponent={
                <Link
                  to={`${AppRoute.auth}/forgot-password`}
                  className="text-success font-size-h6 font-weight-bolder text-hover-success"
                >
                  {t('forgotPassword')}?
                </Link>
              }
              inputElement={
                <FastField name="password">
                  {({ field, form, meta }) => (
                    <KTFormInput
                      name={field.name}
                      value={field.value}
                      onChange={(value) => {
                        form.setFieldValue(field.name, value);
                      }}
                      onBlur={() => {
                        form.setFieldTouched(field.name, true);
                      }}
                      enableCheckValid
                      isValid={_.isEmpty(meta.error)}
                      isTouched={meta.touched}
                      feedbackText={meta.error}
                      type={KTFormInputType.password}
                      solidBackground
                      additionalInputClassName="h-auto p-6 rounded-lg"
                      placeholder={t('enterPassword')}
                    />
                  )}
                </FastField>
              }
            />

            {/* action */}
            <div className="pb-lg-0 pb-5 text-center">
              <button
                type="submit"
                className="btn btn-success font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3 w-100 d-flex align-items-center justify-content-center"
              >
                {t('signIn')}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </motion.div>
  );
}

export default SignInForm;
